import React from 'react';
import { ArrowLeft } from 'lucide-react';
import Reveal from './Reveal';

export const LandingCTA = ({ landing, navigate }) => {
  return (
    <section className="relative overflow-hidden bg-[#0A192F] py-24 md:py-32" data-testid="landing-cta">
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, #0d9488 0, transparent 45%), radial-gradient(circle at 80% 70%, #f54c07 0, transparent 45%)' }} />
      <Reveal className="relative z-10 mx-auto max-w-3xl px-5 text-center">
        <h2 className="font-display text-3xl font-black text-white sm:text-4xl lg:text-5xl" data-testid="landing-cta-title">
          {landing?.cta_title || 'جاهز لتحويل إدارة منشأتك؟'}
        </h2>
        <p className="mt-5 text-lg text-slate-300" data-testid="landing-cta-subtitle">
          {landing?.cta_subtitle || 'ابدأ تجربتك المجانية لمدة 30 يومًا واكتشف كيف تساعدك تسيار على إدارة أعمالك الرياضية بكفاءة.'}
        </p>
        <div className="mx-auto mt-9 flex flex-col justify-center gap-4 sm:flex-row">
          <button
            onClick={() => navigate('/register')}
            className="group flex items-center justify-center gap-2 rounded-full bg-gradient-to-l from-orange-500 to-orange-400 px-9 py-4 text-base font-bold text-white shadow-[0_0_30px_rgba(245,76,7,0.35)] transition-all hover:-translate-y-0.5 hover:shadow-[0_0_40px_rgba(245,76,7,0.55)]"
            data-testid="landing-cta-btn"
          >
            {landing?.cta_button_text || 'ابدأ تجربتك المجانية'}
            <ArrowLeft className="h-4 w-4 transition-transform group-hover:-translate-x-1" />
          </button>
          <button
            onClick={() => navigate('/login')}
            className="flex items-center justify-center rounded-full border border-white/20 px-9 py-4 text-base font-bold text-white transition-colors hover:border-white/50 hover:bg-white/10"
            data-testid="landing-cta-secondary-btn"
          >
            {landing?.cta_secondary_text || 'تسجيل الدخول'}
          </button>
        </div>
      </Reveal>
    </section>
  );
};

export default LandingCTA;
